/* ============================================================
   Caché Perfume · Tienda — buscador + Caché Match
   ------------------------------------------------------------
   Los filtros de categoría y etiqueta NO viven acá: son enlaces
   reales de Shopify (recargan la página con la colección o el
   tag correcto). Eso es lo que hace que funcionen sobre el
   catálogo entero y no solo sobre lo que está cargado.

   Este archivo se ocupa de las dos cosas que SÍ tienen que pasar
   sin recargar:

     1 · El buscador, que esconde tarjetas de la página actual
         mientras se escribe. Al enviar el formulario se va a la
         búsqueda nativa de Shopify, que sí busca en todo.

     2 · Caché Match, que no esconde nada: REORDENA las tarjetas
         de mejor a peor según las cuatro preguntas.

   Cada producto declara sus atributos con tags de Shopify:

       match:occasion:date
       match:climate:night
       match:style:sweet
       match:risk:premium

   La sección las escribe en data-match-* de cada tarjeta. Un
   producto sin tags puntúa neutro: no se rompe nada, solo queda
   en el medio del orden.
   ============================================================ */
(function () {
  'use strict';

  function montarTienda() {
    var raiz = document.querySelector('[data-shop]');
    if (!raiz || raiz.dataset.listo === '1') return;
    raiz.dataset.listo = '1';

    var grid    = raiz.querySelector('[data-shop-grid]');
    var vacio   = raiz.querySelector('[data-shop-empty]');
    var cuenta  = raiz.querySelector('[data-shop-count]');
    if (!grid) return;

    var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('.product'));
    var total    = tarjetas.length;

    /* El contador de "All Products" en la barra lateral (data-count) ya lo
       manda el servidor con collection.products_count: no lo tocamos acá. */

    /* ==========================================================
       1 · Buscador
       ---------------------------------------------------------
       Filtra sobre nombre + marca de las tarjetas ya pintadas.
       ========================================================== */
    var form  = document.querySelector('[data-shop-form]');
    var input = document.querySelector('[data-shop-search]');

    function normalizar(s) {
      return (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    tarjetas.forEach(function (t) {
      t.dataset.buscable = normalizar(
        (t.dataset.name || '') + ' ' + (t.dataset.brand || '')
      );
    });

    /* CAG-007: el check "Show sold out" cambia las tarjetas sin recargar */
    grid.addEventListener('cache:tarjetas', function () {
      tarjetas = Array.prototype.slice.call(grid.querySelectorAll('.product'));
      total = tarjetas.length;
      tarjetas.forEach(function (t, i) {
        t.dataset.buscable = normalizar((t.dataset.name || '') + ' ' + (t.dataset.brand || ''));
        t.dataset.orden = i;
      });
      if (cuenta) delete cuenta.dataset.original;
      aplicarBusqueda();
    });

    function aplicarBusqueda() {
      var q = normalizar(input ? input.value.trim() : '');

      /* Sin búsqueda activa: no tocamos el contador. El servidor ya
         puso ahí el total REAL de la colección (collection.products_count),
         que casi siempre es más grande que las tarjetas de esta página. */
      if (!q) {
        tarjetas.forEach(function (t) { t.hidden = false; });
        if (vacio) vacio.hidden = true;
        if (cuenta) cuenta.textContent = cuenta.dataset.original || cuenta.textContent;
        return;
      }

      var visibles = 0;
      tarjetas.forEach(function (t) {
        var pasa = t.dataset.buscable.indexOf(q) !== -1;
        t.hidden = !pasa;
        if (pasa) visibles++;
      });

      /* ⚠️ Este filtro es sólo un ADELANTO sobre las tarjetas de esta
         página. El catálogo completo vive en la búsqueda de Shopify,
         a donde va el form al enviarse. Por eso, cuando acá no hay
         coincidencias, no decimos "no hay nada": invitamos a buscar
         en todo el catálogo. */
      if (vacio) {
        vacio.hidden = visibles !== 0;
        if (visibles === 0) {
          vacio.innerHTML = 'Nothing on this page matches &ldquo;' + (input.value.trim()) +
            '&rdquo;. <b>Press Enter to search the full catalog.</b>';
        }
      }
      pintarCuenta(visibles);
    }

    function pintarCuenta(n) {
      if (!cuenta) return;
      if (!cuenta.dataset.original) cuenta.dataset.original = cuenta.textContent;
      cuenta.textContent = n + ' on this page · press Enter to search all';
    }

    if (input) {
      var espera;
      input.addEventListener('input', function () {
        clearTimeout(espera);
        espera = setTimeout(aplicarBusqueda, 140);
      });
    }

    /* El submit se va a la búsqueda nativa: busca en TODO el catálogo,
       no solo en la página que está cargada. */
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input ? input.value.trim() : '';
        if (!q) { e.preventDefault(); return; }
        /* deja que el form haga su GET normal a /search */
      });
    }

    /* ==========================================================
       2 · Caché Match — reordena, no esconde
       ---------------------------------------------------------
       Cada acierto suma. El empate se rompe por el orden original,
       así que sin nada elegido la grilla queda exactamente como
       la mandó Shopify.
       ========================================================== */
    var barra = raiz.querySelector('[data-match]');
    if (!barra) { aplicarBusqueda(); return; }

    var selects = Array.prototype.slice.call(barra.querySelectorAll('[data-match-group]'));
    var resumen = barra.querySelector('[data-match-sum]');
    var estado  = barra.querySelector('[data-match-status]');
    var limpiar = barra.querySelector('[data-match-clear]');
    var textoBase = resumen ? resumen.textContent : '';

    /* El orden con el que llegaron, para poder volver y para desempatar */
    tarjetas.forEach(function (t, i) { t.dataset.orden = i; });

    var PESOS = { occasion: 3, climate: 2, style: 3, risk: 2 };

    function puntuar(tarjeta, elegido) {
      var p = 0;
      for (var grupo in elegido) {
        if (!elegido[grupo]) continue;
        var valor = tarjeta.dataset['match' + grupo.charAt(0).toUpperCase() + grupo.slice(1)];
        if (!valor) continue;                       /* sin tag: neutro */
        if (valor.split(',').indexOf(elegido[grupo]) !== -1) p += PESOS[grupo] || 1;
      }
      return p;
    }

    function aplicarMatch() {
      var elegido = {};
      var cuantos = 0;
      selects.forEach(function (s) {
        var v = s.value;
        elegido[s.dataset.matchGroup] = v;
        if (v) cuantos++;
      });

      if (limpiar) limpiar.hidden = cuantos === 0;

      if (cuantos === 0) {
        /* Vuelta al orden original */
        tarjetas
          .slice()
          .sort(function (a, b) { return a.dataset.orden - b.dataset.orden; })
          .forEach(function (t) { grid.appendChild(t); });

        if (resumen) resumen.textContent = textoBase;
        if (estado)  estado.textContent = '';
        return;
      }

      var conPuntaje = tarjetas.map(function (t) {
        return { el: t, p: puntuar(t, elegido), i: +t.dataset.orden };
      });

      conPuntaje.sort(function (a, b) {
        if (b.p !== a.p) return b.p - a.p;
        return a.i - b.i;
      });

      conPuntaje.forEach(function (o) { grid.appendChild(o.el); });

      var aciertos = conPuntaje.filter(function (o) { return o.p > 0; }).length;

      if (resumen) {
        var textos = selects
          .filter(function (s) { return s.value; })
          .map(function (s) { return s.options[s.selectedIndex].text; });
        resumen.textContent = textos.join(' · ');
      }
      if (estado) {
        estado.textContent = aciertos
          ? 'Ranked ' + aciertos + ' matching perfume' + (aciertos === 1 ? '' : 's') + ' first'
          : 'No perfume matches all your answers yet';
      }
    }

    selects.forEach(function (s) {
      s.addEventListener('change', aplicarMatch);
    });

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        selects.forEach(function (s) { s.value = ''; });
        aplicarMatch();
      });
    }

    aplicarBusqueda();
    aplicarMatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montarTienda);
  } else {
    montarTienda();
  }

  /* En el personalizador la sección se repinta sin recargar */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-shop]')) {
      var r = e.target.querySelector('[data-shop]');
      if (r) r.dataset.listo = '';
      montarTienda();
    }
  });
})();
